module.exports = __webpack_public_path__ + "img/CopyDark.8be7e853.svg";